import { createGlobalStyle } from 'styled-components';
import {
  FONT_WEIGHT_BOLD,
  GRAY_LIGHTER_3,
  HEADER_APP_HEIGHT,
  PLACEHOLDER_COLOR,
  MAIN_COLOR,
} from './variables';
import { ZINDEX } from '../helpers/constants';

export const GlobalStyle = createGlobalStyle`
  html {
    scroll-behavior: smooth;
  }
  
  body {
    background-color: ${GRAY_LIGHTER_3} !important;
    font-family: 'Open Sans', Arial, Helvetica, sans-serif !important;
    #modules-merchant-products {
      padding-top: 60px;
    }
  }
  .ReactModal__Body--open {
    overflow-y: hidden;
  }

  .navbar-dashboard {
    height: ${HEADER_APP_HEIGHT};
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.15);
    z-index: ${ZINDEX.TOP} !important;
    background-color: ${MAIN_COLOR};
    position: fixed;
    width: 100%;
    top: 0;
  }

  @keyframes spin {
    0% {
      transform:rotate(0)
    }
    100% {
      transform:rotate(360deg)
    }
  }

  ::placeholder {
    opacity: 1;
    color: ${PLACEHOLDER_COLOR};
    font-size: 13px;
    font-weight: ${FONT_WEIGHT_BOLD};
  }
`;



// WEBPACK FOOTER //
// ./src/styles/globals.js